import { Configurations } from './configurations.model';
import * as ConfigurationsActions from './configurations.actions';

export interface State {
  configurations: Configurations;
}

const initialState: State = {

  configurations: {
    ConfiguationValues: ''
  }

};

export function configurationReducer(state = initialState, action: ConfigurationsActions.ConfigurationActions) {
  switch (action.type) {
    case (ConfigurationsActions.ADD_CONFIGURATION):
      const updatedConfiguration: Configurations = action.payload;
      let updatedConfigurations = state.configurations;
      updatedConfigurations = updatedConfiguration;
      return {
        ...state,
        configurations: updatedConfigurations
      };

    default:
      return state;
  }
}
